import moment from 'moment';

const lastHumanTrackDateFormatter = (params) => {
  // Check to see if this row has a data point yet
  if (!params.node?.data?.lastHumanTrackDate) {
    return '';
  }
  const trackDate = params.node?.data?.lastHumanTrackDate;
  return moment(trackDate).local().format('MM/DD/YY HH:mm');
};

const originPickupDateFormatter = (params) => {
  // Check to see if this row has a data point yet
  if (!params.node?.data?.originPickupDate) {
    return '';
  }
  const date = params.node?.data?.originPickupDate;
  return moment(date).utc().format('MM/DD/YY');
};

const destinationDropOffDateFormatter = (params) => {
  if (!params.node?.data?.destinationDropOffDate) {
    return '';
  }
  const date = params.node?.data?.destinationDropOffDate;
  return moment(date).utc().format('MM/DD/YY');
};

const problemsFormatter = (params) => {
  // Check to see if this row has a data point yet
  if (!params.node?.data?.loadId) {
    return '';
  }

  const problems = params.node?.data?.problems;
  if (!problems || problems.length === 0) {
    return 'None';
  } if (problems.length === 1) {
    return problems[0];
  }
  return `${problems.length} problems`;
};

/**
 * Maps load data to an object that AG grid can consume.
 * See https://www.ag-grid.com/react-grid/ for more details.
 * @return {object} - Table Config Object
 */
export const trackingQueueColumnDefs = [
  {
    cellRenderer: 'statusIndicator',
    pinned: 'left',
    headerClass: ['column-header', 'no-right-border'],
    cellClass: 'indicator-cell',
    sortable: false,
    width: 40,
  },
  {
    headerName: 'Load ID',
    field: 'billOfLadingNumber',
    pinned: 'left',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Status',
    field: 'tlStatus',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 100,
  },
  {
    headerName: 'Origin City',
    field: 'originCity',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Origin State',
    field: 'originState',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Origin Pickup Date',
    field: 'originPickupDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
    valueGetter: originPickupDateFormatter,
  },
  {
    headerName: 'Dest. City',
    field: 'destinationCity',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Dest. State',
    field: 'destinationState',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Dest. Drop Off Date',
    field: 'destinationDropOffDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 160,
    valueGetter: destinationDropOffDateFormatter,
  },
  {
    headerName: 'Carrier',
    field: 'carrierName',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 140,
  },
  {
    headerName: 'Carrier Rep',
    field: 'carrierRepName',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 140,
  },
  {
    headerName: 'Customer',
    field: 'customerName',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
  },
  {
    headerName: '# of Stops',
    field: 'numberOfStops',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 80,
  },
  {
    headerName: 'Last Human Update',
    field: 'lastHumanTrackDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
    valueGetter: lastHumanTrackDateFormatter,
  },
  {
    headerName: 'Visibility App',
    field: 'visibilityAppStatus',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
  },
  {
    headerName: 'Problems',
    field: 'problems',
    headerClass: ['column-header', 'no-right-border'],
    cellClass: ['standard-cell', 'no-right-border'],
    sortable: false,
    width: 160,
    valueGetter: problemsFormatter,
  },
];

/**
 * Maps load data to an object that AG grid can consume.
 * See https://www.ag-grid.com/react-grid/ for more details.
 * @return {object} - Table Config Object
 */
export const trackingLTLQueueColumnDefs = [
  {
    cellRenderer: 'statusIndicator',
    pinned: 'left',
    headerClass: ['column-header', 'no-right-border'],
    cellClass: 'indicator-cell',
    sortable: false,
    width: 40,
  },
  {
    headerName: 'Load ID',
    field: 'billOfLadingNumber',
    pinned: 'left',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'PRO#',
    field: 'proNumber',
    pinned: 'left',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Status',
    field: 'ltlStatus',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 100,
  },
  {
    headerName: 'Last Human Update',
    field: 'lastHumanTrackDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
    valueGetter: lastHumanTrackDateFormatter,
  },
  {
    headerName: 'Shipper',
    field: 'shipper',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 100,
  },
  {
    headerName: 'Origin City',
    field: 'originCity',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Origin State',
    field: 'originState',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Origin Pickup Date',
    field: 'originPickupDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
    valueGetter: originPickupDateFormatter,
  },
  {
    headerName: 'Consignee',
    field: 'consignee',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 100,
  },
  {
    headerName: 'Dest. City',
    field: 'destinationCity',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Dest. State',
    field: 'destinationState',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 110,
  },
  {
    headerName: 'Dest. Delivery Date',
    field: 'destinationDropOffDate',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 160,
    valueGetter: destinationDropOffDateFormatter,
  },
  {
    headerName: 'Customer',
    field: 'customerName',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 150,
  },
  {
    headerName: 'Carrier',
    field: 'carrierName',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 140,
  },
  {
    headerName: 'Service Type',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    valueGetter: () => ('LTL'),
    sortable: false,
    width: 110,
  },
  {
    headerName: 'Problems',
    field: 'problems',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    sortable: false,
    width: 160,
    valueGetter: problemsFormatter,
  },
  {
    headerName: 'Sales Rep',
    field: 'salesRep',
    headerClass: 'column-header',
    cellClass: 'standard-cell',
    width: 140,
  },
  {
    headerName: 'P/U #',
    field: 'pickupNumber',
    headerClass: ['column-header', 'no-right-border'],
    cellClass: ['standard-cell', 'no-right-border'],
    width: 110,
  },
];
